import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import MainLayout from '../components/MainLayout';
import InventoryAnalytics from '../components/InventoryAnalytics';
import SalesAnalytics from '../components/SalesAnalytics';
import usePageTitle from '../utils/usePageTitle';

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const TabHeader = styled.div`
  display: flex;
  background-color: #172A2A;
  border-radius: 16px;
  padding: 8px;
  gap: 8px;
  width: fit-content;
`;

const TabButton = styled.button<{ $active: boolean }>`
  background-color: ${props => props.$active ? '#24BA7D' : 'transparent'};
  color: ${props => props.$active ? '#FFFFFF' : '#609F94'};
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.43;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.$active ? '#24BA7D' : '#1F3737'};
    color: ${props => props.$active ? '#FFFFFF' : '#FFFFFF'};
  }
`;

const TabContent = styled.div`
  width: 100%;
`;

const Statistics: React.FC = () => {
  usePageTitle('Статистика');
  const [activeTab, setActiveTab] = useState<'inventory' | 'sales'>('inventory');

  const handleTabChange = (tab: 'inventory' | 'sales') => {
    setActiveTab(tab);
  };

  return (
    <MainLayout activePage="statistics">
      <TabContainer data-tutorial="statistics-header">
        <TabHeader data-tutorial="statistics-tabs">
          <TabButton 
            $active={activeTab === 'inventory'} 
            onClick={() => handleTabChange('inventory')}
            data-tutorial="inventory-analytics-tab"
          >
            Статистика инвентаря
          </TabButton>
          <TabButton 
            $active={activeTab === 'sales'} 
            onClick={() => handleTabChange('sales')}
            data-tutorial="sales-analytics-tab"
          >
            Статистика продаж
          </TabButton>
        </TabHeader>

        <TabContent data-tutorial="statistics-content">
          {activeTab === 'inventory' && <InventoryAnalytics />}
          {activeTab === 'sales' && <SalesAnalytics />}
        </TabContent>
      </TabContainer>
    </MainLayout>
  );
};

export default Statistics; 